module.exports = __webpack_public_path__ + "static/img/badorange.af98273.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/badorange.jpg
// module id = 8pLM
// module chunks = 1